import React, { createContext, useContext, useState, useCallback } from "react";

// Centralized locale dictionaries. German (de) is the primary/default language.
// All three languages MUST share the same keys.
const dict = {
  de: {
    "nav.home": "Startseite",
    "nav.services": "Dienstleistungen",
    "nav.services_all": "Alle Dienstleistungen",
    "nav.wallets": "Unterstützte Wallets",
    "nav.wallets_all": "Alle Wallets",
    "nav.how": "So funktioniert es",
    "nav.pricing": "Preise",
    "nav.resources": "Ressourcen",
    "nav.about": "Über uns",
    "nav.blog": "Blog",
    "nav.kb": "Wissensdatenbank",
    "nav.faq": "FAQ",
    "nav.crypto": "Kryptowährungen",
    "nav.security": "Sicherheit",
    "nav.contact": "Kontakt",
    "cta.start": "Wiederherstellung starten",
    "cta.dashboard": "Geschützter Bereich",
    "cta.login": "Anmelden",
    "cta.request": "Bewertung anfragen",
    "cta.how": "Unser Vorgehen ansehen",
    "footer.tagline": "Recovers Crypto analysiert Transaktionen, strukturiert Nachweise und unterstützt bei der Verwaltung von Fällen im Zusammenhang mit Kryptobetrug. Informativer Inhalt, keine Rechts- oder Finanzberatung.",
    "footer.services": "Dienstleistungen",
    "footer.wallets": "Wallets",
    "footer.resources": "Ressourcen",
    "footer.legal": "Rechtliches",
    "footer.how": "So funktioniert es",
    "footer.pricing": "Preise",
    "footer.blog": "Blog",
    "footer.reviews": "Bewertungen",
    "footer.terms": "AGB",
    "footer.privacy": "Datenschutz",
    "footer.cookie": "Cookie-Richtlinie",
    "footer.disclaimer_link": "Haftungsausschluss",
    "footer.complaints": "Beschwerden",
    "footer.contact": "Kontakt",
    "footer.eurla": "EURLA und Rechtsexperten ansehen →",
    "footer.disclaimer": "Recovers Crypto garantiert keine Wiederherstellung von Vermögenswerten und bietet keine direkte Rechtsberatung, sofern nicht ausdrücklich und rechtlich autorisiert. Jeder Fall hängt von den verfügbaren Nachweisen, verifizierbaren Transaktionen, der geltenden Gerichtsbarkeit und der Zusammenarbeit relevanter Plattformen, Fachleute oder Behörden ab.",
    "footer.rights": "Alle Rechte vorbehalten.",
    "company.title": "Unternehmensinformationen",
    "company.form": "Rechtsform",
    "company.reg": "Handelsregisternummer (KvK)",
    "company.vat": "USt-IdNr.",
    "company.email": "E-Mail",
    "company.directions": "Wegbeschreibung",
    "status.account.active": "Aktiv",
    "status.account.suspended": "Ausgesetzt",
    "status.account.blocked": "Gesperrt",
    "status.account.archived": "Archiviert",
    "status.verification.unverified": "Nicht verifiziert",
    "status.verification.pending": "Ausstehend",
    "status.verification.verified": "Verifiziert",
    "status.verification.rejected": "Abgelehnt",
    "common.loading": "Wird geladen…",
    "common.save": "Speichern",
    "common.cancel": "Abbrechen",
    "common.search": "Suchen",
    "common.empty": "Keine Daten verfügbar",
    "topbar.1": "Vertrauliche Erstbewertung",
    "topbar.2": "Non-custodial-Prozess",
    "topbar.3": "Fernbetreuung oder nach Termin",
    "trust.identity": "Identität und Eigentum geprüft",
    "trust.nda": "Vertraulichkeitsvereinbarung verfügbar",
    "trust.contract": "Transparenter Vertragsprozess",
    "trust.access": "Kontrollierter Dokumentenzugriff",
  },
  it: {
    "nav.home": "Home",
    "nav.services": "Servizi",
    "nav.services_all": "Tutti i servizi",
    "nav.wallets": "Wallet supportati",
    "nav.wallets_all": "Tutti i wallet",
    "nav.how": "Come funziona",
    "nav.pricing": "Prezzi",
    "nav.resources": "Risorse",
    "nav.about": "Chi siamo",
    "nav.blog": "Blog",
    "nav.kb": "Knowledge Base",
    "nav.faq": "FAQ",
    "nav.crypto": "Criptovalute",
    "nav.security": "Sicurezza",
    "nav.contact": "Contatti",
    "cta.start": "Avvia un recupero",
    "cta.dashboard": "Area riservata",
    "cta.login": "Accedi",
    "cta.request": "Richiedi una valutazione",
    "cta.how": "Scopri come lavoriamo",
    "footer.tagline": "Recovers Crypto analizza le transazioni, organizza le prove e assiste nella gestione dei casi relativi a frodi crypto. Contenuti informativi, non consulenza legale o finanziaria.",
    "footer.services": "Servizi",
    "footer.wallets": "Wallet",
    "footer.resources": "Risorse",
    "footer.legal": "Legale",
    "footer.how": "Come funziona",
    "footer.pricing": "Prezzi",
    "footer.blog": "Blog",
    "footer.reviews": "Recensioni",
    "footer.terms": "Termini",
    "footer.privacy": "Privacy",
    "footer.cookie": "Cookie Policy",
    "footer.disclaimer_link": "Disclaimer",
    "footer.complaints": "Reclami",
    "footer.contact": "Contatti",
    "footer.eurla": "Consulta EURLA e i professionisti legali →",
    "footer.disclaimer": "Recovers Crypto non garantisce il recupero degli asset e non fornisce direttamente consulenza legale, salvo ove espressamente e legalmente autorizzato. Ogni caso dipende dalle prove disponibili, dalle transazioni verificabili, dalla giurisdizione applicabile e dalla collaborazione di piattaforme, professionisti o autorità competenti.",
    "footer.rights": "Tutti i diritti riservati.",
    "company.title": "Informazioni societarie",
    "company.form": "Forma giuridica",
    "company.reg": "Numero di registrazione presso la Camera di Commercio olandese (KvK)",
    "company.vat": "Partita IVA",
    "company.email": "Email",
    "company.directions": "Indicazioni stradali",
    "status.account.active": "Attivo",
    "status.account.suspended": "Sospeso",
    "status.account.blocked": "Bloccato",
    "status.account.archived": "Archiviato",
    "status.verification.unverified": "Non verificato",
    "status.verification.pending": "In verifica",
    "status.verification.verified": "Verificato",
    "status.verification.rejected": "Rifiutato",
    "common.loading": "Caricamento…",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "common.search": "Cerca",
    "common.empty": "Nessun dato disponibile",
    "topbar.1": "Valutazione iniziale riservata",
    "topbar.2": "Processo non-custodial",
    "topbar.3": "Assistenza da remoto o su appuntamento",
    "trust.identity": "Identità e titolarità verificate",
    "trust.nda": "Accordo di riservatezza disponibile",
    "trust.contract": "Processo contrattuale trasparente",
    "trust.access": "Accesso controllato ai documenti",
  },
  en: {
    "nav.home": "Home",
    "nav.services": "Services",
    "nav.services_all": "All services",
    "nav.wallets": "Supported wallets",
    "nav.wallets_all": "All wallets",
    "nav.how": "How it works",
    "nav.pricing": "Pricing",
    "nav.resources": "Resources",
    "nav.about": "About",
    "nav.blog": "Blog",
    "nav.kb": "Knowledge Base",
    "nav.faq": "FAQ",
    "nav.crypto": "Cryptocurrencies",
    "nav.security": "Security",
    "nav.contact": "Contact",
    "cta.start": "Start a recovery",
    "cta.dashboard": "Client area",
    "cta.login": "Sign in",
    "cta.request": "Request an assessment",
    "cta.how": "Explore our process",
    "footer.tagline": "Recovers Crypto analyzes transactions, organizes evidence and helps manage cases related to crypto fraud. Informational content, not legal or financial advice.",
    "footer.services": "Services",
    "footer.wallets": "Wallets",
    "footer.resources": "Resources",
    "footer.legal": "Legal",
    "footer.how": "How it works",
    "footer.pricing": "Pricing",
    "footer.blog": "Blog",
    "footer.reviews": "Reviews",
    "footer.terms": "Terms",
    "footer.privacy": "Privacy",
    "footer.cookie": "Cookie Policy",
    "footer.disclaimer_link": "Disclaimer",
    "footer.complaints": "Complaints",
    "footer.contact": "Contact",
    "footer.eurla": "Explore EURLA legal professionals →",
    "footer.disclaimer": "Recovers Crypto does not guarantee asset recovery and does not directly provide legal advice unless expressly and lawfully authorized. Each case depends on the available evidence, verifiable transactions, applicable jurisdiction and the cooperation of relevant platforms, professionals or authorities.",
    "footer.rights": "All rights reserved.",
    "company.title": "Company information",
    "company.form": "Legal form",
    "company.reg": "Dutch Chamber of Commerce registration number (KvK)",
    "company.vat": "VAT number",
    "company.email": "Email",
    "company.directions": "Directions",
    "status.account.active": "Active",
    "status.account.suspended": "Suspended",
    "status.account.blocked": "Blocked",
    "status.account.archived": "Archived",
    "status.verification.unverified": "Unverified",
    "status.verification.pending": "Pending",
    "status.verification.verified": "Verified",
    "status.verification.rejected": "Rejected",
    "common.loading": "Loading…",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.search": "Search",
    "common.empty": "No data available",
    "topbar.1": "Confidential initial assessment",
    "topbar.2": "Non-custodial process",
    "topbar.3": "Remote assistance or by appointment",
    "trust.identity": "Identity and ownership verified",
    "trust.nda": "Confidentiality agreement available",
    "trust.contract": "Transparent contractual process",
    "trust.access": "Controlled document access",
  },
};

const I18nContext = createContext(null);
const SUPPORTED = ["de", "it", "en"];

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("rc_lang");
    return SUPPORTED.includes(saved) ? saved : "de";
  });
  const changeLang = useCallback((l) => {
    if (!SUPPORTED.includes(l)) l = "de";
    localStorage.setItem("rc_lang", l);
    setLang(l);
    if (localStorage.getItem("rc_token")) {
      import("@/lib/api").then(({ default: api }) => api.patch("/profile", { preferred_language: l }).catch(() => {}));
    }
  }, []);
  const t = useCallback((key) => (dict[lang] && dict[lang][key]) || dict.de[key] || key, [lang]);
  return (
    <I18nContext.Provider value={{ lang, changeLang, t }}>{children}</I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);

// Convenience hook: returns an inline translator L(it, en, de) bound to the active language.
// German is the product default; if a DE string is ever missing we fall back to EN (never Italian).
export const useL = () => {
  const { lang } = useI18n();
  return (it, en, de) => (lang === "en" ? en : lang === "de" ? (de ?? en ?? it) : it);
};
